import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Cart from "./components/Cart/Cart";
import Claims from "./components/Claims/Claims";
import NewClaim from "./components/Claims/NewClaim";
import Transactions from "./components/Claims/Transactions";
import Warrenties from "./components/Claims/Warrenties";
import CreateBulk from "./components/CreateBulk";
import Dashboard from "./components/Dashboard/Dashboard";
import Login from "./components/Login";
import Marketing from "./components/Marketing";
import Profile from "./components/MyProfile/Profile";
import UserAndRoles from "./components/MyProfile/UserAndRoles";
import DelegateUserAndRoles from "./components/MyProfile/DelegateUserAndRoles";
import OpenOrderDetail from "./components/Orders/OpenOrderDetails";
import OpenOrders from "./components/Orders/OpenOrders";
import OrderDetail from "./components/Orders/OrderDetail";
import Orders from "./components/Orders/Orders";
import PendingOrders from "./components/Orders/PendingOrders";
import ProductDetails from "./components/Orders/ProductDetails";
import ProfomaDoc from "./components/Orders/ProfomaDoc";
import ShipmentDetail from "./components/Orders/ShipmentDetails";
import Shipments from "./components/Orders/Shipments";
import PaymentDoc from "./components/PaymentDoc";
import Payments from "./components/Payments";
import ResetForm from "./components/ResetForm";
import ResetPasswordForm from "./components/ResetPassword";
import ShipmentDoc from "./components/ShipmentDoc";
import ShopForTyres from "./components/ShopForTyres";
import SignUp from "./components/SignUp";
import TermsNConditions from "./components/TermsNConditions";
import ThankQ from "./components/ThankYou";
import { initInterceptors } from "./config/endpoint";
import Admin from "./admin/index";
import CheckComponent from "./components/CheckComponent";
import { useHistory, useLocation } from "react-router-dom";
import OnWaterReport from "./components/Orders/OnWaterReport";
import { customerHasAccess } from "./config/helper";
const ProtectedRoute = ({ component: Component, module, ...rest }) => {
  const maintainace = useSelector(
    (state) => state.orders?.products?.maintainace
  );
  const logout = useSelector((state) => state?.orders?.products?.logout);
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    const permissions = localStorage.getItem("permissions");
    if (
      localStorage.getItem("is_super_admin") &&
      localStorage.getItem("token") &&
      !maintainace &&
      !logout
    ) {
      history.push(
        `/admin/${permissions ? permissions?.split(",")?.[0] : "customers"}`
      );
    }
    // eslint-disable-next-line
  }, []);

  // Check auth
  if (!localStorage.getItem("token") || maintainace || logout) {
  return (
    <Redirect
      to={{
        pathname: "/",
        state: { from: location.pathname, search: location.search },
      }}
    />
  );
}

  const userType = localStorage.getItem("user_type") || "";
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");

  // Special rule for delegate-user-roles
  if (rest.path === "/delegate-user-roles") {
    // Non-delegate users → always allowed
    if (userType !== "delegate_user") {
      return <Route {...rest} render={(props) => <Component {...props} />} />;
    }
    // Delegate users → require manage_delegates
    if (!permissions?.manage_delegates) {
      return <Redirect to="/dashboard" />;
    }
  }

  // Normal module-based access
  if (!customerHasAccess(module)) {
    return <Redirect to="/dashboard" />;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  if (localStorage.getItem("token") && rest.path !== "/reset_password") {
    return <Redirect to={"/dashboard"} />;
  }
  return (
    <Route {...rest} render={(props) => <Component {...rest} {...props} />} />
  );
};
function App() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const maintainace = useSelector(
    (state) => state.orders?.products?.maintainace
  );

  // Removed the code to set expire time on click
  // const handleClickSetExpire = () => {
  //   localStorage.setItem("expiresAt", moment().add(1, "hour").unix() * 1000);
  // };
  // useEffect(() => {
  //   window.addEventListener("click", handleClickSetExpire);

  //   return () => {
  //     window.removeEventListener("click", handleClickSetExpire);
  //   };
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    initInterceptors(dispatch, state);
    // eslint-disable-next-line
  }, [maintainace]);

  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path={"/admin/*"} component={Admin} />
          <Route
            exact={true}
            path={"/terms-and-conditions"}
            component={TermsNConditions}
          />
          <PrivateRoute exact path="/reset-password" component={ResetForm} />
          <PrivateRoute
            exact
            path="/reset_password"
            component={ResetPasswordForm}
          />
          <PrivateRoute exact path="/thank-you" component={ThankQ} />
          <ProtectedRoute
            exact
            path="/shop-for-tyres"
            component={ShopForTyres} module="new_order"
          />
          <ProtectedRoute exact path="/marketing" component={Marketing} module="marketing" />
          <ProtectedRoute exact path="/warranties" component={Warrenties} module="claims" />
          <ProtectedRoute exact path="/transactions" component={Transactions} module="claims" />
          <ProtectedRoute exact path="/dashboard" component={Dashboard} />
          <ProtectedRoute
            exact
            path="/open-order-detail"
            component={OpenOrderDetail} module="my_orders"
          />
          <ProtectedRoute
            exact
            path="/product-detail"
            component={ProductDetails} module="new_order"
          />
          <ProtectedRoute
            exact
            path="/order-detail/:id"
            component={OrderDetail} module="my_orders"
          />
          <ProtectedRoute exact path="/order-detail" component={OrderDetail} module="my_orders" />
          <ProtectedRoute
            exact
            path="/shipment-detail"
            component={ShipmentDetail} module="my_orders"
          />
          <ProtectedRoute
            exact
            path="/shipment-detail/:id"
            component={ShipmentDetail} module="my_orders"
          />
          <ProtectedRoute exact path="/orders" component={Orders} module="my_orders" />
          <ProtectedRoute exact path="/cart" component={Cart} module="new_order" />
          <ProtectedRoute
            exact
            path="/pending-actions"
            component={PendingOrders} module="my_orders"
          />
          <ProtectedRoute exact path="/claims" component={Claims} module="claims" />
          <ProtectedRoute exact path="/payments" component={Payments} module="my_orders" />
          <ProtectedRoute exact path="/open-orders" component={OpenOrders} module="my_orders" />
          <ProtectedRoute exact path="/sign-up" component={SignUp} />
          <ProtectedRoute exact path="/track-shipments" component={Shipments} module="my_orders" />
          <ProtectedRoute
            exact
            path="/on-water-report"
            component={OnWaterReport} module="my_orders"
          />
          <ProtectedRoute exact path="/user-roles" component={UserAndRoles} />
          <ProtectedRoute exact path="/delegate-user-roles" component={DelegateUserAndRoles} />
          <ProtectedRoute exact path="/profile" component={Profile} />
          <ProtectedRoute exact path="/new-claim" component={NewClaim} module="claims" />
          <ProtectedRoute exact path="/view-claim/:id" component={NewClaim} module="claims" />
          <ProtectedRoute exact path="/create-bulk" component={CreateBulk} module="new_order" />
          <PrivateRoute exact path="/" component={Login} />
          <ProtectedRoute exact path="/performa-doc" component={ProfomaDoc} module="my_orders" />
          <ProtectedRoute exact path="/payment-doc" component={PaymentDoc} module="my_orders" />
          <ProtectedRoute exact path="/shipment-doc" component={ShipmentDoc} module="my_orders" />

          <ProtectedRoute
            exact
            path="/payment-doc/:id"
            component={PaymentDoc} module="my_orders"
          />
          <ProtectedRoute
            exact
            path="/shipment-doc/:id"
            component={ShipmentDoc} module="my_orders"
          />
          <Route path="*" component={CheckComponent} />
        </Switch>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        closeOnClick
      />
    </div>
  );
}

export default App;
